import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";
import { AbstractControl, FormGroupDirective, NgForm, ReactiveFormsModule } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { BaseInputComponent } from "../base-input/base-input.component";

/**
 * Shows validation errors while the user types (dirty), after blur (touched), or after submit.
 * Material's default matcher omits dirty, so messages only appeared after leaving the field.
 */
class InvalidWhenDirtyTouchedOrSubmittedMatcher implements ErrorStateMatcher {
    isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return !!(control && control.invalid && (control.dirty || control.touched || !!form?.submitted));
    }
}

@Component({
    selector: "text-input-form-field",
    standalone: true,
    templateUrl: "./text-input-form-field.component.html",
    styleUrl: "./text-input-form-field.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, NgIf],
})
export class TextInputFormFieldComponent extends BaseInputComponent {
    @Input() type: string = "text";
    @Input() step?: string;
    @Input() autocomplete?: string;

    readonly textFieldErrorStateMatcher: ErrorStateMatcher = new InvalidWhenDirtyTouchedOrSubmittedMatcher();
}
